/**
 * The `?tab=` search param shared by the driver detail (`$driverId.tsx`) and
 * create (`new.tsx`) routes — both render the same Details/Assignment tab shell.
 */
export type DriverDetailTab = 'details' | 'assignment';
export const DRIVER_DETAIL_TABS = ['details', 'assignment'] as const satisfies readonly DriverDetailTab[];

/**
 * Falls back to Details for a hand-edited URL requesting a tab the current context lacks
 * access to (assignments hidden on an existing driver, or no assignments permission while
 * creating) — defensive against a `Tabs` root left with no matching trigger for its `value`.
 */
export function resolveDriverDetailTab(
  requestedTab: DriverDetailTab | undefined,
  showAssignmentTab: boolean,
): DriverDetailTab {
  if (requestedTab === 'assignment' && !showAssignmentTab) {
    return 'details';
  }
  return requestedTab ?? 'details';
}

/** Default tab is omitted from the URL, mirroring `useDataTableNavigation`'s `handleTabChange`. */
export function withDriverDetailTab<T extends { tab?: DriverDetailTab }>(prev: T, next: DriverDetailTab): T {
  return { ...prev, tab: next === 'details' ? undefined : next };
}
